import {GetObligationHistoryParams} from 'domain/usecases';
import {makeGetObligationHistory} from 'main/factories/usecases';

export const getObligationHistory = async (params: GetObligationHistoryParams) => {
	if (!params.exercicio.length) {
		return [];
	}

	try {
		const response = await makeGetObligationHistory().get(params);
		return response;
	} catch (error) {
		throw new Error();
	}
};
